// extracted by mini-css-extract-plugin
export default {"next_order":"Xv","recurringdis":"Yv","reactivate_button":"Zv","order__summary_title":"aw","order__summary_items":"bw","order__summary_item":"cw","order__summary_item_title":"ew","order__summary_item_quantity":"fw","order__item_separator":"gw","discount":"hw","promowrapper":"iw"};
    if(module.hot) {
      // 1721922359905
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  